import { render, staticRenderFns } from "./TicketSummary.vue?vue&type=template&id=2c213b64&"
import script from "./TicketSummary.vue?vue&type=script&lang=js&"
export * from "./TicketSummary.vue?vue&type=script&lang=js&"
import style0 from "./TicketSummary.vue?vue&type=style&index=0&id=2c213b64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports